<div class="home-container">
    <div class="title-container">
        <h1>CARITO DA SILVA</h1>
        <h5>FULL STACK DEVELOPER</h5>
        <!-- <div class="row title-row">

            <div class="col s12 m12 l12 slide-top">
                <h1>CARITO DA SILVA</h1>
            </div>
            <div class="col s12 m12 l12 slide-top">
                <h1>FRONT-END DEVELOPER</h1>
            </div>
            <div class="col s12 m12 l12 slide-top">
                <h1 class="pixel-heart-conainer">COFFEE ADICT <span><img class="pixel-heart coffee" src="https://firebasestorage.googleapis.com/v0/b/portafoliocaritodasilva.appspot.com/o/la-mejor-madre.svg?alt=media&token=900e5982-a75b-41fd-85d0-78c9e0a24fb3" alt=""></span></h1>
            </div>
            <div class="col s12 m12 l12 slide-top">
                <h1 class="pixel-heart-conainer">CODER LOVER <span><img class="pixel-heart" src="https://firebasestorage.googleapis.com/v0/b/portafoliocaritodasilva.appspot.com/o/pixel-heart-2779422_960_720.png?alt=media&token=30188a4e-5c0a-441f-ae95-0131f2c9b00e" alt=""></span>!</h1>
            </div>
        </div> -->
    </div>
    <div class="container" id="fotoContent">
        <div class="row foto">
            <div id="foto" class="col s12 m8 offset-m2">
                <img src="https://firebasestorage.googleapis.com/v0/b/portafoliocaritodasilva.appspot.com/o/caritoLogo.png?alt=media&token=fd133c70-55ac-4597-ac1a-0f663f3515f8"
                    alt="carito" class="responsive-img shake-slow">
            </div>
        </div>
    </div>



    <!-- BOTONES -->

    <div class="row buttons-container">
        <div class="col s12 m2">
            <button class='lined thin' data-target="modal1" id="myWorld" routerLink="bio"
                routerLinkActive="active">MyWorld</button>
        </div>
        <div class="col s12 m3">
            <button class='lined thin' data-toggle="modal" id="favoriteCodes" routerLink="favorites-codes"
                routerLinkActive="active">FavoriteCodes</button>
        </div>
        <div class="col s12 m2">
            <button class='lined thin' href="#modal1" data-toggle="modal" routerLink="conversemos"
                routerLinkActive="active" id="letsTalk">LetsTalk</button>
        </div>

    </div>
</div>